'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# GradCapBadgeSVG
An SVG badge shaped like the state of Ohio containing a graduation cap icon.
 */
var GradCapBadgeSVG = function GradCapBadgeSVG(_ref) {
  var height = _ref.height,
      width = _ref.width,
      badgeColor = _ref.badgeColor,
      iconColor = _ref.iconColor;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 473 492',
      'aria-label': 'Graduation Cap Badge',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'Graduation Cap Badge'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'A badge shaped like the state of Ohio containing a graduation cap icon'
    ),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement(
        'g',
        {
          transform: 'translate(0.000000, -1.000000)',
          fillRule: 'nonzero'
        },
        _react2.default.createElement(
          'g',
          {
            fill: badgeColor
          },
          _react2.default.createElement('path', {
            d: 'M463.576245,2.17241379 C476.080843,-0.362068966 471.550192,9.23275862 471.550192,14.3017241 C471.731418,79.8362069 471.731418,145.551724 471.731418,211.086207 C471.731418,274.086207 471.731418,336.905172 471.731418,399.905172 C465.388506,401.534483 458.683142,402.62069 452.521456,404.974138 C390.904598,428.327586 329.468966,451.681034 268.033333,475.215517 C258.247126,479.017241 249.36705,484.448276 239.943295,489.155172 C236.137548,493.5 230.700766,493.137931 223.63295,489.155172 C213.665517,484.086207 204.241762,478.112069 193.911877,473.948276 C129.395402,448.965517 64.8789272,424.525862 0.181226054,399.724138 C0.181226054,272.456897 0.181226054,145.37069 0.181226054,18.1034483 C54.3678161,18.2844828 108.554406,18.8275862 162.55977,18.2844828 C176.695402,18.1034483 186.481609,21.7241379 195.18046,33.4913793 C214.752874,60.6465517 240.486973,69.6982759 273.470115,58.6551724 C298.47931,50.3275862 324.575862,45.8017241 349.766284,38.1982759 C388.004981,26.9741379 425.7,14.3017241 463.576245,2.17241379 Z'
          })
        ),
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(75.079365, 157.500000)',
            fill: iconColor
          },
          _react2.default.createElement('path', {
            d: 'M329.705251,80.5380117 C327.708989,81.9532164 325.905913,83.6900585 323.78086,84.7192982 C274.711445,108.134503 225.642031,131.48538 176.572617,154.900585 C169.038337,158.502924 161.439661,158.760234 153.969776,155.222222 C134.522318,146.087719 115.139256,136.760234 95.756193,127.432749 C94.2106996,126.725146 92.987184,125.309942 91.6348773,124.216374 C92.987184,122.994152 94.146304,121.450292 95.6917974,120.614035 C114.946069,110.51462 134.20034,100.54386 153.583403,90.6374269 C155.193292,89.8011696 157.447136,89.6081871 159.250212,89.9298246 C165.689768,90.8947368 171.871741,90.6374269 177.602946,87.2280702 C185.008435,82.7894737 185.07283,75.1988304 177.602946,71.0175439 C168.84515,66.128655 159.894168,66.3859649 151.329558,71.5321637 C147.530221,73.8479532 145.791541,77.4502924 147.272638,82.2748538 C141.412643,85.3625731 135.552647,88.3859649 129.692651,91.4736842 C114.752882,99.1929825 99.813113,106.912281 84.9377394,114.760234 C83.0058727,115.789474 81.4603793,117.526316 79.0777437,119.45614 C71.9942325,116.111111 63.9447879,112.444444 55.9597389,108.649123 C39.4100808,100.80117 22.9248182,92.9532164 6.37516012,85.0409357 C5.666809,84.7192982 5.02285343,84.3976608 4.37889786,84.0116959 C2.25384449,82.8538012 -0.450768898,81.6315789 0.257582227,78.994152 C0.772746682,77.0643275 2.70461339,74.9415205 4.57208453,74.0409357 C31.231845,61.1754386 58.0203967,48.4385965 84.8089483,35.7017544 C107.025415,25.1520468 129.241882,14.4736842 151.522745,4.05263158 C155.128896,2.38011696 159.185816,1.47953216 162.985154,0.192982456 C164.273065,0.192982456 165.560977,0.192982456 166.848888,0.192982456 C170.197457,1.22222222 173.739212,1.86549708 176.830199,3.34502924 C225.899613,26.6315789 274.969028,49.9824561 324.038442,73.3976608 C326.0991,74.3625731 327.83778,76.0350877 329.769646,77.3216374 C329.705251,78.3508772 329.705251,79.4444444 329.705251,80.5380117 Z'
          }),
          _react2.default.createElement('path', {
            d: 'M267.627934,120.935673 C267.627934,130.777778 267.627934,140.105263 267.627934,149.432749 C267.627934,151.877193 267.434747,154.385965 267.627934,156.830409 C268.336285,165.321637 265.052112,172.269006 259.707281,178.508772 C248.11608,192.017544 233.305102,200.894737 217.013026,207.391813 C180.178768,222.122807 143.473301,221.350877 107.089811,205.526316 C104.900362,204.561404 103.934429,203.532164 103.612451,200.959064 C101.294211,181.081871 98.653993,161.269006 96.2069618,141.391813 C96.0781707,140.233918 96.0781707,139.076023 95.9493796,137.339181 C97.6880597,138.111111 99.1047619,138.690058 100.457069,139.333333 C117.908264,147.695906 135.35946,156.05848 152.810656,164.549708 C160.988892,168.538012 168.973941,168.473684 177.152177,164.48538 C206.065782,150.461988 234.979387,136.567251 263.892992,122.672515 C264.858925,122.093567 265.95365,121.643275 267.627934,120.935673 Z'
          }),
          _react2.default.createElement('path', {
            d: 'M84.9377394,133.736842 C86.6764194,146.666667 88.3507039,159.596491 90.089384,172.526316 C92.1500418,188.222222 94.146304,203.918129 96.335753,219.614035 C97.2372908,226.111111 93.8243262,232.093567 87.9643306,233.573099 C81.5247749,235.181287 75.3428014,231.900585 73.2177481,225.467836 C72.7669792,224.181287 72.7669792,222.701754 72.8957703,221.350877 C75.1496148,204.175439 77.4678548,187 79.7860949,169.824561 C81.3959838,157.730994 82.8770816,145.637427 84.422575,133.608187 C84.5513661,133.608187 84.7445527,133.672515 84.9377394,133.736842 Z'
          }),
          _react2.default.createElement('path', {
            d: 'M61.1113834,120.48538 C64.9107212,122.28655 68.2592902,124.216374 71.8654414,125.502924 C74.8920326,126.596491 74.827637,128.526316 74.5056592,131.035088 C73.668517,137.467836 72.8957703,143.964912 72.0586281,150.461988 C70.899508,159.403509 69.8047836,168.409357 68.581268,178.122807 C64.2023701,172.847953 60.9825923,167.766082 60.8538012,161.461988 C60.7250101,148.403509 60.7894056,135.345029 60.7894056,122.28655 C60.8538012,121.77193 60.9825923,121.385965 61.1113834,120.48538 Z'
          })
        )
      )
    )
  );
};

GradCapBadgeSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  badgeColor: _propTypes2.default.string,
  iconColor: _propTypes2.default.string
};

GradCapBadgeSVG.defaultProps = {
  height: undefined,
  width: undefined,
  badgeColor: _config.colors.darkRed,
  iconColor: _config.colors.white
};

GradCapBadgeSVG.displayName = 'GradCapBadgeSVG';

exports.default = GradCapBadgeSVG;
GradCapBadgeSVG.__docgenInfo = {
  'description': '# GradCapBadgeSVG\r\nAn SVG badge shaped like the state of Ohio containing a graduation cap icon.',
  'methods': [],
  'displayName': 'GradCapBadgeSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'badgeColor': {
      'defaultValue': {
        'value': 'colors.darkRed',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'iconColor': {
      'defaultValue': {
        'value': 'colors.white',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    }
  }
};